import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { loginAction } from 'store/login/loginAction';
import { useLoginForm } from 'shared/hooks';
import { Alert } from 'ui';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100vw',
    height: '100vh',
  },
  button: {
    margin: `${theme.spacing(2)} 0`,
  },
  paper: {
    padding: theme.spacing(2),
  },
}));

const Login = ({ dispatch }) => {
  const classes = useStyles();
  const [submitted, setSubmitted] = useState(false);
  const { t } = useTranslation();
  const { isPending, error } = useSelector(({ auth }) => auth);

  const { inputs, handleInputChange } = useLoginForm();

  const handleSubmit = event => {
    event.preventDefault();
    dispatch(loginAction(inputs));
    setSubmitted(true);
  };

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        {error && submitted && !isPending && (
          <Alert message={t('Incorrect login or password')} variant="warning" />
        )}
        <Typography variant="h5" align="center">
          ScopeOne
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            className={classes.field}
            onChange={handleInputChange}
            name="userName"
            type="email"
            label="E-mail address"
            variant="outlined"
            fullWidth
            autoFocus
            required
          />
          <TextField
            className={classes.field}
            onChange={handleInputChange}
            name="password"
            type="password"
            label="Password"
            variant="outlined"
            fullWidth
            required
          />
          <Grid container justifyContent="center">
            <Grid item>
              <Button
                type="submit"
                className={classes.button}
                color="primary"
                variant="contained"
                size="large"
                disabled={isPending}
              >
                {t('Login')}
              </Button>
            </Grid>
          </Grid>
          <Grid container justifyContent="center">
            <Grid item>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <Link color="inherit" href="#">
                Forgot your password?
              </Link>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </div>
  );
};

Login.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = payload => ({ payload });

const ConnectedLogin = connect(mapStateToProps)(Login);

export { ConnectedLogin };
